
import 'babel-polyfill'
import moment from 'moment'
moment.locale(window['LANGUAGE_CODE']);
//
import 'jquery'
let $ = require('jquery');
require('malihu-custom-scrollbar-plugin')($);


import 'angular'
import 'angular-vs-repeat'
import * as PIXI from 'pixi.js'

import * as _ from 'lodash'

import Stats from 'stats.js'

import showAngularStats from 'ng-stats'
window.showAngularStats = showAngularStats;

// // chart
import './chart/wheel_polyfill'
import '../static/webtrader/charting_library/charting_library.min'
//
//
//
import './AppModule'
import './routing'
import './pages/Main'
import './pages/Login'
import './pages/App'
import './services/Account'
import './services/Quotes'
import './services/Trades'
import './services/Feed'
import './services/ModalWindow'
import './utils/Moment'
import './services/OpenListOptions'
import './services/OpenListMarket'
import './utils/Utils'
import './components/TradingView'
import './components/MarketReview'
import './components/OneTouch'
import './components/Cubic'
import './components/CubicOptions'
import './components/Trades'
import './components/Totals'
import './components/TechnicalSignals'
import './components/ListOptions'
import './models/BaseTrade'
import './models/Trade'
import './models/TradeOption'
import './models/Quote'
import './models/QuoteOption'
import './directive/customPlaceHolder'
//
// // forms
import './components/MarketExecution'
import './components/PendingOrder'
import './components/PriceHigherLower'
import './components/Breakout'
import './components/DoubleTouch'
import './components/ExpressOptions'
//
// // form helpers
import './components/Barometer'
import './components/Tabs'
import './components/ValueManager'

// import '../css/app.scss'

